import * as Yup from 'yup';

export const VALIDATORS = {
  required: (validator) => {
    return validator.required('This field is required');
  },
  min: (validator, options) => {
    const { value, message } = options;
    return validator.min(value, message || `Minimum value is ${value}`);
  },
  max: (validator, options) => {
    const { value, message } = options;
    return validator.max(value, message || `Maximum value is ${value}`);
  },
  matches: (validator, options) => {
    const { value, ...rest } = options;

    return validator.matches(value, rest);
  },
  email: (validator, options: any = {}) => {
    const { message } = options;
    return validator.email(message || 'Invalid email format');
  },
  url: (validator, options: any = {}) => {
    const { message } = options;
    return validator.url(message || 'Invalid URL format');
  },
  uuid: (validator, options: any = {}) => {
    const { message } = options;
    return validator.uuid(message || 'Invalid UUID format');
  },
  datetime: (validator, options) => {
    return validator.datetime(options || 'Invalid datetime format');
  },
  lessThan: (validator, options) => {
    const { value, message } = options;
    return validator.lessThan(
      value,
      message || `Value must be less than ${value}`
    );
  },
  moreThan: (validator, options) => {
    const { value, message } = options;
    return validator.moreThan(
      value,
      message || `Value must be more than ${value}`
    );
  },
  positive: (validator) => {
    return validator.positive('Value must be positive');
  },
  negative: (validator) => {
    return validator.negative('Value must be negative');
  },
  length: (validator, options) => {
    const { value, message } = options;
    return validator.length(value, message || `Length must be ${value}`);
  },
  test: (validator, options) => {
    const { name, message, test } = options;
    return validator.test({
      name,
      message,
      test
    });
  },
  when: (validator, options) => {
    const { keys, ...rest } = options;
    return validator.when(keys, rest);
  },
  oneOf: (validator, options) => {
    const { value, message } = options;
    return validator.oneOf(value, message || 'Invalid value');
  },
  notOneOf: (validator, options) => {
    const { value, message } = options;
    return validator.notOneOf(value, message || 'Invalid value');
  },
  nullable: (validator, options) => {
    const { message } = options;
    return validator.nullable(message || "This field can't be null");
  },
  nonNullable: (validator, options) => {
    const { message } = options;
    return validator.nonNullable(message || 'This field must not be null');
  }
};

export const SCHEMA = {
  string: Yup.string(),
  number: Yup.number(),
  array: Yup.array(),
  date: Yup.date(),
  mixed: Yup.mixed(),
  boolean: Yup.boolean(),
  object: Yup.object()
};
